import axios from "axios";
import React, { useEffect, useState } from "react";
import { ApiConnectionString } from "../../constants/ApiConntection";
import NoImagePlaceholder from "../../assets/NoImagePlaceholder.png";
import LoadingSpinner from "../../components/LoadingSpinner";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../hooks/useAuthContext";
import ProfilePlaceHolder from "../../assets/ProfilePlaceHolder.png";
//styled
export default function PaymentResolved({ notification }) {
  const [club, setClub] = useState(null);

  const [isLoading, setIsLoading] = useState(true);
  const [profile, setProfile] = useState(null);
  const { user } = useAuthContext();
  const navi = useNavigate();

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const clubResponse = await axios.get(
        `${ApiConnectionString}/api/club/${notification.clubId}`
      );

      const profileReponse = await axios.get(
        `${ApiConnectionString}/api/BookingProfile/${notification.bookingProfileId}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      if (profileReponse.status == 200) {
        setProfile(profileReponse.data);
      } else {
        setProfile(null);
      }

      if (clubResponse.status === 200) {
        setClub(clubResponse.data);
      } else {
        setClub(null);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // You can set error state here if needed
    } finally {
      setIsLoading(false); // Stop loading state in any case
    }
  };

  useEffect(() => {
    fetchData();
  }, [user]);

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else {
    if (club && profile) {
      return (
        <div className="container text-center bg-white">
          <div className="blueBanner mt-2">
            <p className=" fw-bold p-2">Payment Resolved</p>
          </div>
          <p>{notification.content}</p>
          <div className="row">
            <div className="col">
              <div className="lightBlueBanner">
                <p className="fw-bold p-2">Club</p>
              </div>
              <p
                onClick={() => navi(`/myoneclub/${club.id}`)}
                className="fw-bold red-text pointer"
              >
                {club.name}
              </p>
              <div
                onClick={() => navi(`/myoneclub/${club.id}`)}
                className="circle-crop mx-auto"
              >
                <img
                  src={
                    club.image
                      ? `${ApiConnectionString}/api/ClubProfileImage/${club.id}`
                      : NoImagePlaceholder
                  }
                  alt="Club Image"
                  className="mt-0 pointer"
                />{" "}
              </div>
            </div>
            <div className="col">
              <div className="lightBlueBanner">
                <p className="fw-bold p-2">Profile</p>
              </div>
              <div className="bg-white d-flex profileBox rounded shadow mt-3">
                <div>
                  <img
                    src={
                      profile.image
                        ? `${ApiConnectionString}/api/profileImage/${profile.id}`
                        : ProfilePlaceHolder
                    }
                    alt="Profile Image"
                    width={200}
                    className=" m-3 circle-crop"
                  />
                </div>

                <div className="mx-5 mt-5">
                  <p className="red-text">Username</p>
                  <p className="fw-bold mt-2">{profile.username}</p>
                </div>
                <div className="mx-5 mt-5">
                  <p className="red-text">Name</p>
                  <p className="fw-bold">
                    {profile.firstName + " " + profile.lastName}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="container bg-white">
          <div className="blueBanner mt-2">
            <p className=" fw-bold p-2">Payment Resolved</p>
          </div>

          <p>Not Found</p>
        </div>
      );
    }
  }
}
